/* unplugin-vue-components disabled */import script from "./Pc.vue?vue&type=script&lang=ts&setup=true"
export * from "./Pc.vue?vue&type=script&lang=ts&setup=true"

import "./Pc.vue?vue&type=style&index=0&id=61cbccc6&lang=less"

const __exports__ = script;

export default __exports__